import { render, staticRenderFns } from "./InvocationScrollList.vue?vue&type=template&id=cf0a5c66&scoped=true"
import script from "./InvocationScrollList.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvocationScrollList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InvocationScrollList.vue?vue&type=style&index=0&id=cf0a5c66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0a5c66",
  null
  
)

export default component.exports